import { Path } from '../api/config.js';

/**
* Returns a Promise that resolves to a collection of data from GetPlayerOptions.
* @param {string} resourceId
* @returns {Promise<Object>}
*/
export function getPlayCoverInfo(resourceId, playerName, channelId) {
    return fetch(`${Path.PlayerService}/GetPlayCoverInfo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        body: JSON.stringify({
            "presentationId": resourceId,
            "alternatePlayer": playerName ?? "",
            "channelId": channelId ?? ""
        })
    }).then(result => result.json());
}
